<!-- link -->
<template>
  <div class="miniliink" :class="['miniliink', { inApp: $root.$data.isApp || this.$root.miniprogram }]">
    <!-- <common-title titleName="分校小程序" :zIndex="1000"></common-title> -->
    <div class="miniliink-box">
      <img class="pxind" src="https://iqh-zt-pord-cdn.iqihang.com/25season/mzt/minilink.jpeg" alt="" />

      <button @click="gostudy">前往小程序</button>
    </div>

  </div>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import { GetQueryValue } from '@/utils/tools';
import { miniSchemeUrl } from '@/utils/common';


export default {
  data() {
    return {};
  },
  components: {},
  mounted() {
    this.getSchemeUrl();
  },
  methods: {
    gostudy() {
      this.getSchemeUrl()
    },
    async getSchemeUrl() {
      const schemeLink= await  miniSchemeUrl('wx9e4d0e927c766e76','pages/index/index',`distributorId=${GetQueryValue('distributorId')}`)
      window.location.href=schemeLink;
    },
  },
};
</script>

<style lang="scss" scoped>
.inApp {
  padding-top: 20px !important;
}

.miniliink {
  width: 100%;
  height: 100vh;
  // padding-top: 101px;
  // padding-bottom: 210px;
  background: #f9f9f9;
  user-select: none;

  .miniliink-box {
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }

  button {
    display: block;
    width: 260px;
    height: 70px;
    color: #fff;
    font-weight: 500;
    font-size: 32px;
    line-height: 70px;
    background: #ff6c02;
    border-radius: 45px;
    margin: 200px auto 0;
  }

  .pxind {
    display: block;
    margin: 0 auto;
    width: 200px;
    // height: 200px;
    border-radius: 50%;
  }
}
</style>
